import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { Seating } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/rst/common/seating';
export default ProtoBaseModel.extend({
  isEnabled: attr(Boolean),
  seatAssignmentOption: attr(Seating.SeatAssignmentOption)
});